var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec12Img2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 87,
    viewBox: "0 0 155 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2317 52.8431L30.3118 29.6634L0.292267 86.2826H24.9919L43.2317 52.8431Z",
    fill: "#344EAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8916 0.403809L34.1118 23.2035L50.8316 54.743L51.8765 56.7143L52.6445 58.163H45.8916L35.6318 79.8227H64.1268L67.5513 86.2826H91.871L45.8916 0.403809Z",
    fill: "#344EAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.15 73.706C148.382 79.4742 141.09 83.48 133.128 85.2545C130.553 85.8284 127.942 86.1612 125.328 86.255V66.539C126.507 66.4607 127.682 66.2924 128.844 66.0334C133.155 65.0728 137.103 62.9041 140.226 59.7812L154.15 73.706ZM109.191 83.7254C112.205 84.8151 115.317 85.5585 118.468 85.9518V65.9732C117.596 65.7682 116.733 65.5122 115.885 65.2057C111.732 63.7043 108.092 61.051 105.392 57.5561C102.692 54.0613 101.043 49.8696 100.638 45.4718C100.234 41.0739 101.091 36.6519 103.108 32.7233C105.126 28.7946 108.221 25.522 112.031 23.2885C114.046 22.1072 116.217 21.2425 118.468 20.7133V0.734622C112.705 1.4542 107.123 3.33868 102.072 6.29995C95.0342 10.4256 89.3175 16.4704 85.5909 23.727C81.8642 30.9836 80.2817 39.1516 81.0287 47.2749C81.7756 55.3982 84.8211 63.1407 89.8085 69.596C94.796 76.0513 101.519 80.9524 109.191 83.7254ZM125.328 0.431465C133.481 0.724161 141.381 3.33303 148.104 7.95269L136.952 24.1832C133.507 21.8159 129.491 20.4239 125.328 20.1475V0.431465Z",
    fill: "#344EAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec12Img2);
export default __webpack_public_path__ + "static/media/sec12img2.4a154a8661c40a6ca677b8110178d1af.svg";
export { ForwardRef as ReactComponent };